import { notification } from "antd"
import Breadcrumbs from "components/Common/Breadcrumb"
import moment from "moment"
import React, { useEffect, useState } from "react"
import ConfigUrl, { axiosbaseurl } from "../../config"
import { MdAdd, MdDelete, MdEdit, MdSend } from "react-icons/md"
import { SiTicktick } from "react-icons/si"
import { useNavigate } from "react-router-dom"
import { Container } from "reactstrap"
import Swal from "sweetalert2"
import { IoMdWarning } from "react-icons/io"
import Loader from "pages/Loader"
import { FaChevronLeft, FaChevronRight } from "react-icons/fa"
import PermittedComponent from "PermittedComponent"
import { usePermissionData } from "AppContext"

const Testimonials = () => {

   document.title = "Testimonials | Return First Investments"

  const { checkAccess } = usePermissionData()

  const Navigate = useNavigate()

  const [Data, setData] = useState([])
  const [Users, setUsers] = useState([])
  const [Loading, setLoading] = useState(false)

  useEffect(() => {
    getData()
  }, [])

  async function getData() {
    setLoading(true)
    try {
      const response = await axiosbaseurl.get(`testimonials`)
      if (response?.data?.success) {
        setUsers(response?.data?.data)
        setData(response?.data?.data.reverse())
      }
    } catch (e) {
      console.log("Error", e.response.data.message)
    } finally {
      setLoading(false)
    }
  }

  const filterByName = e => {
    const filteredData = Users.filter(session =>
      session.postedBy.toLowerCase().includes(e.target.value.toLowerCase())
    )

    setData(filteredData)
  }

  const handleDelete = async id => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this Testimonial",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Delete",
      cancelButtonText: "Cancel",
    })

    if (result.isConfirmed) {
      try {
        const response = await axiosbaseurl.delete(
          `/testimonials/${id}`
        ) 

        if (response?.data?.success) {
          notification.open({
            message: (
              <div className="d-flex align-items-center">
                <div className="pr-20">
                  <SiTicktick className="text-success fs-4 me-2" />
                </div>
                <div className="succes-message">Testimonial Deleted Successfully.</div>
              </div>
            ),
            placement: "topRight",
          })

          getData()
        }
      } catch (error) {
        notification.open({
          message: (
            <div className="d-flex">
              <div className="pr-10">
                <IoMdWarning className="text-danger" size={22} />
              </div>
              <div>Opps! Something went wrong.</div>
            </div>
          ),
          description: error?.response?.data?.message,
        })
      }
    }
  }

  const [page, setPage] = useState(1)

  useEffect(() => window.scrollTo(0, 0), [])

  const [items_perpage, setItemsPerPage] = useState(10)

  const total_pages = Math.ceil(Data?.length / items_perpage)

  const final_data = Data?.slice(
    page * items_perpage - items_perpage,
    page * items_perpage
  )

  const changePage = pagecount => {
    if (pagecount > 0 && pagecount <= total_pages) {
      setPage(pagecount)
      window.scrollTo(0, 0)
    }
  }

  return (
    <React.Fragment>
      {Loading && <Loader />}
      <PermittedComponent isAccess={checkAccess(8, 1)}>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumbs title={""} breadcrumbItem={"Testimonials"} />

            <div className="card p-2 py-3">
              <div className="d-flex flex-column flex-xl-row justify-content-between">
                <div className="search-box position-relative">
                  <input
                    className="form-control ps-6"
                    placeholder="Search Testimonials"
                    onChange={filterByName}
                  />
                  <i className="bx bx-search-alt search-icon"></i>

                </div>

                <div>
                  {checkAccess(8, 2) && (
                    <button
                      className="btn Add-Button rounded-5 mt-2 mt-xl-0"
                      onClick={() => Navigate(`${ConfigUrl.appurl}add-testimonial`)}
                    >
                      <MdAdd /> Add Testimonial
                    </button>
                  )}
                </div>
              </div>

              <div className="table-responsive mt-4">
                <table className="mb-0 table Custom-Table">
                  <thead>
                    <tr>
                      <th>Sr No.</th>
                      <th></th>
                      <th>Person Name</th>
                      <th>Testimonial Date</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {final_data?.map((item,index) => (
                      <tr key={item?.id}>
                        <td>{(page - 1) * items_perpage + index + 1}</td>
                        <td className="col-1">
                          <img src={`${ConfigUrl.imageurl}${item?.image}`} className="w-100 object-fit-cover "/>
                        </td>
                        <td>{item?.postedBy.length < 30 ? item?.postedBy : `${item?.postedBy?.slice(0,30)}...`}</td>
                        <td>
                          {moment(item?.postedAt).format("DD MMMM YYYY")}
                        </td>
                        <td className="">
                          {checkAccess(8, 3) && (
                            <button
                              className="btn Edit-Button me-2 rounded-5"
                              onClick={() =>
                                Navigate(
                                  `${ConfigUrl.appurl}edit-testimonial/${item?.id}`
                                )
                              }
                            >
                              <MdEdit /> Edit
                            </button>
                          )}
                          {checkAccess(8, 4) && (
                            <button
                              className="btn delete-Button rounded-5"
                              onClick={() => handleDelete(item?.id)}
                            >
                              <MdDelete /> Delete
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}
                    {
                      final_data.length === 0 && (
                        <tr>
                          <td colSpan={5}>No Data Found</td>
                        </tr>
                      )
                    }
                  </tbody>
                </table>
              </div>
              <div className="d-flex align-items-center justify-content-between my-4 px-2">
                <p className="mb-0 fs-6">
                  Showing {final_data?.length} out of {Data?.length} Testimonials.
                </p>
                <div className="d-flex justify-content-md-start justify-content-center flex-wrap">
                  <div
                    className={`bd-number-pagination cursor-pointer rounded-2 me-2 fs-5`}
                    onClick={() => changePage(page - 1)}
                    style={{cursor:"pointer"}}
                  >
                    <FaChevronLeft />
                  </div>
                  {(() => {
                    const maxVisiblePages = 5;
                    const startPage = Math.max(1, page - Math.floor(maxVisiblePages / 2));
                    const endPage = Math.min(total_pages, startPage + maxVisiblePages - 1);
                    const visiblePages = [];

                    for (let i = startPage; i <= endPage; i++) {
                      visiblePages.push(i);
                    }

                    return visiblePages.map((pagecount) => (
                      <div
                        key={pagecount}
                        className={`bd-number-pagination cursor-pointer rounded-2 me-1 fs-5 ${
                          page === pagecount ? "activepage" : ""
                        }`}
                        style={{cursor:"pointer"}}
                        onClick={() => changePage(pagecount)}
                      >
                        {pagecount < 10 ? "0" + pagecount : pagecount}
                      </div>
                    ));
                  })()}
                  <div
                    className={`bd-number-pagination cursor-pointer rounded-2 ms-2 fs-5`}
                    onClick={() => changePage(page + 1)}
                    style={{cursor:"pointer"}}
                  >
                    <FaChevronRight />
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </PermittedComponent>
    </React.Fragment>
  )
}

export default Testimonials
